<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmhT">
<b>More praise for</b> <i class="sgc-1">From Wonso Pond</i>
</div>
<div class="epiv">
    “At once a folktale and a page-turner that acquires the dignity of tragedy. Samuel Perry has given us a new masterpiece, whose closing question is as urgent for us today as it was in 1934.”
  </div>
<div class="eps">
    —Norma Field, author of <i>In the Realm of a Dying Emperor: Japan at Century’s End</i>
</div>
<div class="epiv">
<div>
       <br/>
</div>“A vibrant account of the travails of Japanese colonialism, as experienced by workers and women, by the pioneering feminist writer of the Korean left.”
  </div>
<div class="eps">
    —Andre Schmid, author of <i>Korea Between Empires: 1895-1919</i>
</div>
<div class="epiv">
<div>
       <br/>
</div>“How refreshing it is to have a good old-fashioned story, told without narrative<br/>
    tricks or artifice. Kang Kyong-ae’s <i>From Wonso Pond</i> is a powerful novel that charts<br/>
    the struggles of her impassioned characters as they learn to live, work, and love.<br/>
    The questions Kang poses and the issues she tackles are as universal as they are<br/>
    enduring. This essential work should be required reading for anyone interested in<br/>
    Korean history and literature.”
  </div>
<div class="eps">
    —Sung J. Woo, author of <i>Everything Asian: A Novel</i>
</div>
<div class="epiv">
<div>
       <br/>
</div>“This novel’s canonical status will remain unchallenged for years to come. It is a rare blessing that the English-language version was produced by Samuel Perry, whose first-rate linguistic talent, literary sensitivity, and scholarly rigor are distinctively channeled through his passion for social change and aesthetic excellence.”
  </div>
<div class="eps">
    —Kyeong-Hee Choi, associate professor of East Asian Languages and Civilizations at the University of Chicago
  </div>
<div class="epiv">
<div>
       <br/>
</div>“<i>From Wonso Pond</i> is a powerful literary indictment of sexual and economic exploitation of the poverty-ridden farming population in 1930s colonial Korea.”
  </div>
<div class="eps">
    —Yung-Hee Kim, professor of Korean Literature at the University of Hawaii at Manoa
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// kang_9781558616530_oeb_fm1_r1.vue?3288aad0